import React, {PropTypes} from 'react';
import TournamentListContainer from './TournamentListContainer.jsx';
import TournamentRequirementModalContainer from './TournamentRequirementModalContainer.jsx';
import RequiredProfileFieldsModalContainer from './RequiredProfileFieldsModalContainer.jsx';
import DisplayIf from 'shared/DisplayIf.jsx';

const RegHome = ({
  activeTournamentsQty,
  paymentMessage,
  loadingTournaments,
  groupName,
  isAllowed,
  onPartnerLoginClick,
  onExitPartnerClick, 
  roles
}) => {
  let isCaptain = !roles.length;

  return (
    <div>
    <TournamentRequirementModalContainer/>
    <RequiredProfileFieldsModalContainer/>
    <DisplayIf condition={!!paymentMessage} className="flex center animated fadeIn">
      <div className="col-xs-12">
        <div className="alert alert-success">{paymentMessage}</div>
      </div>
    </DisplayIf>

    <DisplayIf condition={!isCaptain && !isAllowed && groupName != undefined && groupName !== ''} className="flex center animated fadeIn">
      <div className="col-xs-12">
        <div className="alert alert-danger text-center">
          <div className="row">
            <div className="col-xs-3 text-left cursor-pointer" style={{fontSize: '10px', fontWeight: 'bold'}}>
              <button onClick={onPartnerLoginClick} type="button">
                <i className="fa fa-user" />{` Manage another Partner Hub`}
              </button>
            </div>
            <div className="col-xs-6 text-center">
              {groupName} is not supported by Event Registration.
            </div>
            <div className="col-xs-3 text-right cursor-pointer" style={{fontSize: '10px', fontWeight: 'bold'}}>
              <button onClick={onExitPartnerClick} type="button">
                <i className="fa fa-sign-out" />{` Exit Partner Hub Mode`}
              </button>
            </div>
          </div>
        </div>
      </div>
    </DisplayIf>

    <div className="flex center animated fadeIn">
      <div className="col-xs-12">
        {
          loadingTournaments
              ? <div className="alert alert-info"
                     style={{ margin: "16px" }}>{'Loading tournament data.'}</div>
          : <div>
                {
                  activeTournamentsQty ? 
                    <TournamentListContainer /> :
                    <div className="alert alert-info"
                         style={{ margin: "16px" }}>{'No active tournaments found.'}</div>
                }
            </div>
        }
      </div>
    </div>
  </div>
  );
};

RegHome.propTypes = {
  activeTournamentsQty: PropTypes.number,
  paymentMessage: PropTypes.string,
  maintenanceMessage: PropTypes.string,
  loadingTournaments: PropTypes.bool,
  groupName: PropTypes.string,
  isAllowed: PropTypes.bool,
  onExitPartnerClick: PropTypes.func,
  onPartnerLoginClick: PropTypes.func
};

RegHome.defaultProps = {
  activeTournamentsQty: 0,
  paymentMessage: '',
  maintenanceMessage: null,
  loadingTournaments: true
};

export default RegHome;



// WEBPACK FOOTER //
// ./src/features/registration/home/RegHome.jsx